import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'

export default defineNuxtPlugin((app) => {
  const vuetify = createVuetify({
    icons: {},
    theme: {
      defaultTheme: 'dark',
      themes: {
        light: {
          dark: false,
          colors: {
            primary: '#F9A825',
            secondary: '#212121',
            accent: '#FFC107',
            error: '#D32F2F',
            background: '#FFFFFF',
            surface: '#FFFFFF',
          },
        },
        dark: {
          dark: true,
          colors: {
            primary: '#FFD54F',
            secondary: '#FAFAFA',
            accent: '#FFC107',
            error: '#EF5350',
            background: '#121212',
            surface: '#1E1E1E',
          },
        },
      },
    },
  })

  app.vueApp.use(vuetify)
})
